
  import { defineComponent } from 'vue';

  import constants from '@/common/constants';
  import security from '@/common/mixins/security';

  import AggregatedPageWrapper from '../components/common/AggregatedPageWrapper.vue';
  import { TExportConfig } from '../components/common/ved-aggregated-export-buttons/types';
  import FTSMonthlyFilter from '../components/fts/fts-monthly/FTSMonthlyFilter.vue';
  import FTSMonthlyTable from '../components/fts/fts-monthly/FTSMonthlyTable.vue';
  import { CostTypes, IndicatorTypes, SelectTypes, ShowSections, WeightTypes } from '../types/common-aggregated';
  import { FTSTradeDirections } from '../types/fts-common';
  import { TFTSMonthlyFilterRequest } from '../types/fts-monthly';
  import { TAggregatedPermissions } from '../types/permission';
  import { getFilenameWithPeriod } from '../utils/filename';
  import { getNormalizedCountriesFilter } from '../utils/fts/countries';

  import links from '@/utils/links';

  const DEFAULT_FILTER: TFTSMonthlyFilterRequest = {
    codes: [],
    productsGroupsIds: [],
    productsTwoSignsIds: [],
    productsFourSignsIds: [],
    productsSixSignsIds: [],
    productsEightSignsIds: [],
    productsNineSignsIds: [],
    productsTenSignsIds: [],
    usersGroupsIds: [],
    statisticsCountryIds: [],
    originCountryIds: [],
    departureCountryIds: [],
    destinationCountryIds: [],
    senderOkatoIds: [],
    recipientOkatoIds: [],
    isLoadWeeklyData: true,
    periods: [],
    customsProcedureIds: [],
    tradeDirectionId: FTSTradeDirections.EXPORT_IMPORT,
    selectTypeId: SelectTypes.CUMULATIVE_TOTAL,
    indicatorTypeId: IndicatorTypes.PRICE,
    isCumulativeTotal: true,
    isTotalShare: false,
    weightId: WeightTypes.TONS,
    isAdditionalUnits: false,
    isAdditionalUnitsWithQuantity: false,
    costInId: CostTypes.THOUSANDS_OF_DOLLARS,
    moreCost: 10,
    showSectionId: ShowSections.PRODUCTS,
    isProductsInGroups: false,
  };

  export default defineComponent({
    name: 'FTSMonthly',
    components: {
      FTSMonthlyTable,
      FTSMonthlyFilter,
      AggregatedPageWrapper,
    },
    mixins: [security],
    data(): {
      defaultFilter: TFTSMonthlyFilterRequest;
      filter: TFTSMonthlyFilterRequest;
      filterForExport: TFTSMonthlyFilterRequest;
    } {
      return {
        defaultFilter: { ...DEFAULT_FILTER },
        filter: { ...DEFAULT_FILTER },
        filterForExport: { ...DEFAULT_FILTER },
      };
    },
    mounted() {
      this.checkPermissionAndRedirect(this.getPermissions.view);
    },
    computed: {
      getPermissions(): TAggregatedPermissions {
        return {
          view: constants.Permissions.ForeignTradeAnalyticsFtsMonthRequestView,
          build: constants.Permissions.ForeignTradeAnalyticsFtsMonthRequestBuild,
          export: constants.Permissions.ForeignTradeAnalyticsFtsMonthRequestDownload,
        };
      },

      getNormalizedFilters() {
        return {
          ...this.filter,
          ...getNormalizedCountriesFilter(this.filter),
        };
      },
      getNormalizedExportFilters() {
        return {
          ...this.filterForExport,
          ...getNormalizedCountriesFilter(this.filterForExport),
        };
      },
      getExportConfig(): TExportConfig {
        return {
          pdfFileName: this.getFileName(this.filter),
          excelFileName: this.getFileName(this.filterForExport),
          excel: {
            permissionCode: this.getPermissions.export,
            url: links.ved.fts.monthly.exportExcel,
            params: this.getNormalizedExportFilters,
          },
        };
      },
    },
    methods: {
      searchFilter(filter: TFTSMonthlyFilterRequest) {
        this.filter = { ...filter };
      },
      updateFilter(filter: TFTSMonthlyFilterRequest) {
        this.filterForExport = { ...filter };
      },
      getFileName(filter: TFTSMonthlyFilterRequest) {
        return getFilenameWithPeriod('Запрос_по_базе_ФТС_(месяц)', filter.periods);
      },
    },
  });
